<template>
    <div class="assets">
        <empty type="tasks" title="Breakdown your request into smaller to do's">
            <div class="badge badge--warning">Coming Soon!</div>
        </empty>
    </div>
</template>

<script>
import Empty from '../Global/Empty'
export default {
    name: 'Tasks',

    components: {
        Empty
    }
}
</script>
